import CloseIcon from "@mui/icons-material/Close";
import { Dialog, DialogContent, IconButton, Link, Typography } from "@mui/material";
import useLocales from "hooks/useLocales";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const WHISTLEBLOWING_LINK = "https://desigualintegrity.i2-ethics.com/#/";
const SEEN_KEY_PREFIX = "desigual_whistleblowing_seen_";

export const WhistleblowingModal = () => {
  const { translate: t } = useLocales();
  const supplier = useSelector((state: any) => state.supplier.supplier);
  const onboarding = useSelector((state: any) => state.onboarding);
  const [open, setOpen] = useState(false);

  const isDesigual = supplier?.customOnboardingTemplate === "DesigualTemplate";
  const supplierId = supplier?.id;

  const isOnboardingDone =
    supplier?.isOnboardingDone && !!onboarding?.isOnBoardingStatus;

  useEffect(() => {
    if (!isDesigual || !isOnboardingDone || !supplierId) return;
    const seenKey = `${SEEN_KEY_PREFIX}${supplierId}`;
    if (localStorage.getItem(seenKey)) return;
    localStorage.setItem(seenKey, "1");
    setOpen(true);
  }, [isDesigual, isOnboardingDone, supplierId]);

  if (!isDesigual) return null;

  return (
    <Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm" fullWidth>
      <IconButton
        onClick={() => setOpen(false)}
        sx={{ position: "absolute", top: 8, right: 8 }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent sx={{ pt: 5, pb: 3 }}>
        <Typography variant="h6" fontWeight={700} sx={{ mb: 2 }}>
          {t("desigual.whistleblowingTitle")}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {t("desigual.whistleblowingBodyBeforeLink")}
          {" "}
          <Link href={WHISTLEBLOWING_LINK} target="_blank" rel="noopener">
            {WHISTLEBLOWING_LINK}
          </Link>
          {" "}
          {t("desigual.whistleblowingBodyAfterLink")}
          {" "}
          <Link href="https://desigual.com" target="_blank" rel="noopener">
            desigual.com
          </Link>
          .
        </Typography>
      </DialogContent>
    </Dialog>
  );
};
